module.exports = __webpack_public_path__ + "static/media/18_yo_desktop.7fcea7b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/backgrounds/18_yo_desktop.jpg
// module id = 521
// module chunks = 0